import SectionHeading from "./SectionHeading";
import { classicMovies } from "@/mocks/home";
import type { MovieDetail } from "../types";

interface ClassicsSectionProps {
  onOpen: (movie: MovieDetail) => void;
}

export default function ClassicsSection({ onOpen }: ClassicsSectionProps) {
  return (
    <section id="classic" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="05"
          eyebrow="经典老片"
          title="经典老片回看"
          desc="越到深夜越适合重看老片。画质修复过，标题、年份、一句话简介都摆在一起，慢慢挑。"
        />

        <ul className="mt-6 grid grid-cols-1 gap-x-10 md:grid-cols-2">
          {classicMovies.map((movie) => (
            <li
              key={movie.id}
              className="flex items-start gap-4 border-b border-background-300/35 py-5"
            >
              <span className="flex h-12 w-12 shrink-0 flex-col items-center justify-center rounded-md border border-secondary-300/30 bg-secondary-100/10">
                <i className="ri-history-line text-lg text-secondary-200" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-display text-base font-bold text-foreground-950">{movie.title}</h3>
                  <span className="font-label text-sm text-foreground-500">{movie.year}</span>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] text-foreground-500">
                    {movie.genre}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{movie.summary}</p>
              </div>
              <button
                type="button"
                onClick={() =>
                  onOpen({
                    title: movie.title,
                    year: movie.year,
                    genre: movie.genre,
                    summary: movie.summary,
                    tags: ["经典老片"],
                  })
                }
                className="mt-0.5 flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-500/40 px-3 py-1.5 text-xs text-primary-200 transition-colors hover:bg-primary-500/15"
              >
                <i className="ri-play-fill" />
                回看
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}